import { HiCake } from "react-icons/hi";
import React, { memo } from "react";
import { Button } from "src/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuTrigger,
} from "src/components/ui/dropdown-menu";
import BirthdayDropdownMenuContent from "./BirthdayDropdownMenuContent";

interface BirthdayDropdownMenuProps {
  isOpen: boolean;
  handleToggle: () => void;
}

const BirthdayDropdownMenu: React.FC<BirthdayDropdownMenuProps> = ({
  isOpen,
  handleToggle,
}) => {
  return (
    <DropdownMenu open={isOpen} onOpenChange={handleToggle}>
      <DropdownMenuTrigger asChild>
        <Button className="px-0" variant="ghost">
          <div className="relative">
            <HiCake size={32} color={"#433C34"} />
          </div>
        </Button>
      </DropdownMenuTrigger>

      {isOpen && <BirthdayDropdownMenuContent />}
    </DropdownMenu>
  );
};

export default memo(BirthdayDropdownMenu);
